const NileWaveDivider = ({ className = "", flip = false }: { className?: string; flip?: boolean }) => (
  <div className={`w-full overflow-hidden ${flip ? "rotate-180" : ""} ${className}`}>
    <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-8 md:h-12" preserveAspectRatio="none" aria-hidden="true" focusable="false" role="presentation">
      <path
        d="M0 30C240 10 480 50 720 30C960 10 1200 50 1440 30V60H0V30Z"
        fill="hsl(var(--primary))"
        fillOpacity="0.12"
      />
      <path
        d="M0 40C240 20 480 55 720 35C960 15 1200 55 1440 35"
        stroke="hsl(var(--primary))"
        strokeWidth="1"
        strokeOpacity="0.3"
      />
    </svg>
  </div>
);

export default NileWaveDivider;
